import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, number, oneOf, shape } from 'prop-types';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import isInternationalPrice from '../../utils/isInternationalPrice';
import { Complement, Container, Description, Price, FastDeliveryIcon, PickupStoreIcon, ExpressDeliveryIcon, Delivery1hIcon, Delivery24hIcon, DeliveryRTomorrowIcon, AirPlaneIcon } from './shipping-item.styles';

const ShippingItem = _ref => {
  let {
    complement,
    description,
    price,
    currency,
    time,
    type,
    unit,
    freeShippingLabel
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["complement", "description", "price", "currency", "time", "type", "unit", "freeShippingLabel"]);

  const renderDeliveryTime = fill => {
    const showInternationalShipping = isInternationalPrice({
      currency
    });
    if (showInternationalShipping) return /*#__PURE__*/React.createElement(AirPlaneIcon, {
      fill: fill
    });
    if (unit === 'hours' && time <= 2) return /*#__PURE__*/React.createElement(ExpressDeliveryIcon, {
      fill: fill
    });
    if (unit === 'days' && time === 0) return /*#__PURE__*/React.createElement(Delivery1hIcon, {
      fill: fill
    });
    if (unit === 'days' && time === 1) return /*#__PURE__*/React.createElement(DeliveryRTomorrowIcon, {
      fill: fill
    });
    if (unit === 'working_days' && time === 1) return /*#__PURE__*/React.createElement(Delivery24hIcon, {
      fill: fill
    });
    return !showInternationalShipping && /*#__PURE__*/React.createElement(FastDeliveryIcon, {
      fill: fill
    });
  };

  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": "shipping-item"
  }, props), ['store_pickup', 'pickup_point'].includes(type) && /*#__PURE__*/React.createElement(PickupStoreIcon, {
    fill: "background.dark"
  }) || renderDeliveryTime('background.dark'), /*#__PURE__*/React.createElement(Description, null, description, /*#__PURE__*/React.createElement(Complement, {
    as: "span"
  }, complement)), !!Number(price) && /*#__PURE__*/React.createElement(Price, null, currencyFormatter({
    value: price
  })) || /*#__PURE__*/React.createElement(Price, {
    free: true
  }, freeShippingLabel));
};

ShippingItem.defaultProps = {
  freeShippingLabel: 'Frete Grátis',
  unit: ''
};
process.env.NODE_ENV !== "production" ? ShippingItem.propTypes = {
  description: string.isRequired,
  complement: string.isRequired,
  price: shape({
    price: string.isRequired
  }),
  currency: string.isRequired,
  type: string.isRequired,
  time: number.isRequired,
  freeShippingLabel: string,
  unit: oneOf(['hours', 'days', 'working_days'])
} : void 0;
export default ShippingItem;